// extracted by mini-css-extract-plugin
export default {"driver-status-icon":"azQIuM3l9a8z__VYXJXy","driverStatusIcon":"azQIuM3l9a8z__VYXJXy"};